import { TranslationsActionTypes } from "./translationsTypes";
const initialState = {
    list: []
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case TranslationsActionTypes.FETCH_TRANSLATION_SUCCESS:
            return Object.assign(Object.assign({}, state), { list: action.payload });
        default:
            return state;
    }
};
export { reducer as translationReducer };
